import { render } from "./MdBadge.vue?vue&type=template&id=64dd2f85"
import script from "./MdBadge.vue?vue&type=script&lang=js"
export * from "./MdBadge.vue?vue&type=script&lang=js"

import "./MdBadge.vue?vue&type=style&index=0&id=64dd2f85&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__